var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import { API_UAT_URL, DEV_SANDBOX_URL } from '../../const/urls';
export var initialState = {
    apigeeURL: API_UAT_URL,
    assetsURL: DEV_SANDBOX_URL,
    serviceFileURL: '',
    lang: 'en',
    authDomain: '',
    targetOrigin: '',
    rcApigeeClientId: '',
    psccApigeeClientId: ''
};
var mfeConfigSlice = createSlice({
    name: 'mfeConfig',
    initialState: initialState,
    reducers: {
        updateMfeConfig: function (state, action) {
            var _a = action.payload, _b = _a.hosts, apigee = _b.apigee, assets = _b.assets, serviceFile = _b.serviceFile, lang = _a.lang, authDomain = _a.authDomain, targetOrigin = _a.targetOrigin, psccApigeeClientId = _a.psccApigeeClientId, rcApigeeClientId = _a.rcApigeeClientId;
            var apigeeURL = apigee.toString();
            var assetsURL = assets.toString();
            var serviceFileURL = serviceFile.toString();
            return __assign(__assign({}, state), { apigeeURL: apigeeURL, assetsURL: assetsURL, authDomain: authDomain, lang: lang, psccApigeeClientId: psccApigeeClientId, rcApigeeClientId: rcApigeeClientId, serviceFileURL: serviceFileURL, targetOrigin: targetOrigin });
        }
    }
});
export var updateMfeConfig = mfeConfigSlice.actions.updateMfeConfig;
export default mfeConfigSlice.reducer;
//# sourceMappingURL=mfeConfig.slice.js.map